import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MuiCell,
  MuiCellDef,
  MuiColumnDef,
  MuiFooterCell,
  MuiFooterCellDef,
  MuiHeaderCell,
  MuiHeaderCellDef
} from './mui-cells.component';
import {
  MuiFooterRow,
  MuiFooterRowDef,
  MuiHeaderRow,
  MuiHeaderRowDef,
  MuiNoDataRow,
  MuiRow,
  MuiRowDef
} from './mui-rows.component';
import { MuiTable } from './mui-table.component';


const EXPORTED_DECLARATIONS = [
  MuiTable,

  // Template Def
  MuiColumnDef,
  MuiHeaderRowDef,
  MuiHeaderCellDef,
  MuiRowDef,
  MuiCellDef,
  MuiFooterCellDef,
  MuiFooterRowDef,

  // Cells
  MuiHeaderCell,
  MuiCell,
  MuiFooterCell,

  // Rows
  MuiHeaderRow,
  MuiRow,
  MuiFooterRow,
  MuiNoDataRow
];


@NgModule({
  imports: [
    CommonModule,
    CdkTableModule
  ],
  declarations: [
    ...EXPORTED_DECLARATIONS
  ],
  exports: [
    ...EXPORTED_DECLARATIONS
  ]
})
export class MuiTableModule {
}
